export function formatDashboardData(
  schemaDashboard,
  presenter,
  startDate,
  endDate,
  filteredObjects
) {
  const gross_sales = filteredObjects.reduce(
    (acc, o) =>
      acc + (Number(o.total) + Number(o.discount_amount) - Number(o.total_tax)),
    0
  );
  const totalDiscountAmount = filteredObjects.reduce(
    (acc, o) => acc + Number(o.discount_amount),
    0
  );
  const totalPretax = filteredObjects.reduce(
    (acc, o) => acc + Number(o.total_pretax),
    0
  );
  const totalTax = filteredObjects.reduce(
    (acc, o) => acc + Number(o.total_tax),
    0
  );
  const totalTaxFree = filteredObjects.reduce(
    (acc, o) => acc + Number(o.total_taxfree),
    0
  );

  const staticRow = {
    gross_sales,
    net_sales: gross_sales - totalDiscountAmount,
    pretax: totalPretax,
    tax: totalTax,
    tax_free: totalTaxFree,
    tax_free_amount: "",
    discount_total: totalDiscountAmount,
  };

  return schemaDashboard.map((obj, i) => {
    const { value } = getValue(obj.label, presenter);
    const extra = i === 0 ? staticRow : {};
    return {
      trans_type: obj.label,
      TotalSales: value,
      start_date: startDate,
      end_date: endDate,
      "": "",
      ...extra,
    };
  });
}

export function getValue(label, presenter) {
  switch (label) {
    case "Delivery":
      return presenter.calculateDeliveryInfo();
    case "Dine In":
      return presenter.calculateDineInfo();
    case "Take Out":
      return presenter.calculateTakeOutInfo();
    case "Grab Food":
      return presenter.calculateGrabFoodInfo();
    case "Pick Up":
      return presenter.calculatePickUpInfo();
    case "Del Time":
      return presenter.calculateDelTimeInfo();
    case "Drive Thru":
      return presenter.calculateDriveInfo();
    case "FoodPanda":
      return presenter.calculatePandaInfo();
    default:
      return { value: 0, percentage: 0 };
  }
}
